import { Mask } from '@/types';
import { getParams } from '@/utils/params';
import { fetchFromDesignerService } from './fetchFromDesignerService';

export const fetchMasks = () =>
  fetchFromDesignerService<{ masks: Mask[] }>('masks', {
    languageCode: getParams().locale.substring(0, 2),
  }).then((data) => data.masks);
